import axios from "../utils/axios";

export const deleteServicePackageGroup = (id: string) => {
  return axios.delete(`/api/v1/servicepackagegroups/${id}`)
}
